import { render, staticRenderFns } from "./RegisterHelpTab.vue?vue&type=template&id=0601611a&"
import script from "./RegisterHelpTab.vue?vue&type=script&lang=js&"
export * from "./RegisterHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports